import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -64 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 ${scrolled ? "nav-scrolled" : ""}`}
      style={{ background: "#ffffff", borderBottom: "1px solid rgba(10,10,10,0.1)" }}
      data-testid="top-navbar"
    >
      <div className="flex items-stretch h-12 md:h-14">
        {/* Logo badge */}
        <a
          href="#top"
          className="flex items-center gap-2.5 px-4 md:px-5 bg-[#000000] text-white shrink-0 select-none"
          data-testid="nav-logo"
        >
          <img src="/brand/emergent-logo-white.png" alt="Emergent" className="h-[15px] w-auto" />
          <span className="font-display font-semibold text-[15px] tracking-tight">Index<sup className="text-[9px] ml-0.5">26</sup></span>
        </a>

        {/* Read the report */}
        <a
          href="#overview"
          className="hidden md:flex items-center gap-1.5 px-6 text-[14px] font-medium text-[#0A0A0A] hover:bg-[#F0F5FF] transition-colors"
          data-testid="nav-read-report"
        >
          Read the Report
          <Plus size={14} strokeWidth={2.5} />
        </a>

        <div className="flex-1" />

        <a
          href="#stories"
          className="hidden sm:flex items-center px-4 md:px-6 text-[14px] font-medium text-[#0A0A0A] hover:bg-[#F0F5FF] transition-colors"
          data-testid="nav-about"
        >
          Operator Stories
        </a>
        <a
          href="#industries"
          className="flex items-center gap-1.5 px-4 md:px-6 text-[14px] font-medium text-[#0A0A0A] hover:bg-[#F0F5FF] transition-colors"
          data-testid="nav-case-studies"
        >
          Industries
          <Plus size={14} strokeWidth={2.5} />
        </a>
      </div>
    </motion.header>
  );
}
